var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUpload = function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFBFBF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.19,
    d: "M4.452 1.937c-.762.125-1.31.359-1.74.792-.927.938-.927 2.448-.927 5.468s0 4.53.928 5.469c.927.938 2.42.938 5.405.938s4.479 0 5.406-.938c.928-.939.928-2.449.928-5.469s0-4.53-.928-5.468c-.428-.433-.977-.667-1.739-.792"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFBFBF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.19,
    d: "M6.45 3.604c.327-.337 1.2-1.667 1.666-1.667m0 0c.467 0 1.339 1.33 1.667 1.667M8.116 1.937V7.27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFBFBF",
    strokeLinejoin: "round",
    strokeWidth: 1.19,
    d: "M14.452 9.27h-3.284c-.561 0-1.002.47-1.25.965-.269.539-.807 1.036-1.8 1.036-.992 0-1.53-.497-1.8-1.036-.247-.495-.688-.964-1.25-.964H1.786"
  })));
};
export default SvgFileUpload;